<template>
  <v-form ref="form">
    <v-card>
      <v-card-title>
        <span class="headline">{{ $vuetify.lang.t('$vuetify.custom.userSpaceAdd') }}</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row class="mt-6">
            <v-col cols="12" >
              <v-text-field
                :rules="[rules.required]"
                :label="$vuetify.lang.t('$vuetify.custom.user.username')+'*'"
                v-model="formData.username"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                :rules="[rules.required]"
                :label="$vuetify.lang.t('$vuetify.custom.user.password')+'*'"
                type="password"
                v-model="formData.password"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                :label="$vuetify.lang.t('$vuetify.custom.user.realname')"
                v-model="formData.realname"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" dark  @click="hiddenDialog">{{ $vuetify.lang.t('$vuetify.custom.cancelBtn') }}</v-btn>
        <v-btn color="success" dark  @click="addUser">{{ $vuetify.lang.t('$vuetify.custom.addBtn') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>
<style></style>
<script>
  export default {
    name: 'user-add',
    model:{
      prop:'dialog',
      event:'parent-event'
    },
    props:{
      dialog:Boolean
    },
    data: () => ({
      formData: {
        username: '',
        password: '',
        realname: ''
      },
      rules: {
        required: value => !!value || '请输入'
      },
    }),
    methods:{
      hiddenDialog(){
        this.$emit('parent-event',false);
        this.$refs.form.reset()
      },
      addUser() {
        if (this.$refs.form.validate()) {
          this.$api.sysUser.addUserBase(this.formData).then(data => {
            if (data.flag) {
              this.$dialog.alert(this.$vuetify.lang.t('$vuetify.custom.addSuccess'));
              this.$emit('initialize')
              this.hiddenDialog();
            }else{
              this.$dialog.alert(data.msg)
              this.$refs.form.reset()
            }
          })

        }
      }
    },
  }
</script>
